const parseReadingTime = (originalValue: number): string => originalValue.toString(10);

export default parseReadingTime;
